import { IApplicationState } from '../../../../../../../types/types';
import { connect } from 'react-redux';
import { ICardMoveToButtonHOCOwnProps } from './types';
import { getPanelButtonShow } from '../../../selectors/getPanelButtonShow';
import { CardMoveToButton } from '../../components/CardMoveToButton/CardMoveToButton';
import { ICardMoveToButtonEvents, ICardMoveToButtonFields } from '../../components/CardMoveToButton/types';
import { onOpened } from './events/onOpened';
import { MOVE_TO_TOOLTIP } from '../../components/CardMoveToButton/constants';
import { CLASS_NAME_BUTTON_HIDE_TITLE, MIN_WIDTH_DISPLAY_MOVE_TO } from '../../../ActionsInHeadSection/constants';
import { getAsidePanelEntityPanelWidth } from '../../../../asidePanel/store/selectors/getAsidePanelEntityPanelWidth';
import * as _ from 'underscore';
import { getUserFollowMoveTo } from '../../../../../../../store/model/authUser/selectors/getUserFollowMoveTo';
import { onToggleFollow } from './events/onToggleFollow';
import {
    getUserCommentsColumnView
} from '../../../../../../../store/model/authUser/selectors/getUserCommentsColumnView';

const mapStateToProps = (
    state: IApplicationState,
    { cardId, boardId, isCommentsColumn }: ICardMoveToButtonHOCOwnProps,
): ICardMoveToButtonFields => {
    const isShow = getPanelButtonShow(state, boardId, cardId);
    const panelWidth = getAsidePanelEntityPanelWidth(state);
    // const isHideTitle = isCommentsColumn && panelWidth < MIN_WIDTH_DISPLAY_MOVE_TO;
    const isHideTitle = true; // KNB-4083
    const tooltip = isHideTitle
        ? MOVE_TO_TOOLTIP
        : null;

    return {
        isFollow: getUserFollowMoveTo(state),
        isShow,
        tooltip,
        className: isHideTitle ? CLASS_NAME_BUTTON_HIDE_TITLE : ''
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: ICardMoveToButtonHOCOwnProps,
): ICardMoveToButtonEvents => {
    return {
        onOpened: () => dispatch(onOpened(boardId)),
        onToggleFollow: () => dispatch(onToggleFollow()),
    }
};

export const CardMoveToButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardMoveToButton);
